import {
  Grid,
  Dialog,
  DialogContent,
  Box,
  CircularProgress,
} from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useState } from 'react'

export const ModalVisualizaReseituario = ({ data: { url }, close }) => {
  const [iframeLoading, setIframeLoading] = useState(true)
  const handleFalse = () => {
    close(false)
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={true} onClose={handleFalse}>
      <DialogContent>
        <Grid container style={{ height: '80vh' }}>
          <Grid item xs={12} style={{ height: '100%' }}>
            {iframeLoading && (
              <Box
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#fff',
                  zIndex: 1,
                }}
              >
                <CircularProgress />
              </Box>
            )}

            <iframe
              src={url}
              width="100%"
              height="100%"
              style={{ border: 'none', display: 'block' }}
              onLoad={() => setIframeLoading(false)}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
export default memo(ModalVisualizaReseituario, isEqual)
